<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-12/12 px-4">
      <Form pageType="Edit" :onSubmit="onSubmit" :alertType="this.alertType" :alertMessage="this.alertMessage"
        :clientProps="client" />
    </div>
  </div>

</template>
<script>
import { UseAppStore } from '@/stores/AppStore';
import Form from "@/views/admin/api-management/Form.vue";
import APIDataService from "@/services/APIDataService";
import ErrorHandler from "@/ErrorHandler";

export default {
  setup() {
    const appStore = UseAppStore();
    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("api-management", "API Management", "/admin/api-management")
    return {
      appStore
    }
  },
  created() {
    this.getClient()
  },
  data() {
    return {
      alertType: '',
      alertMessage: '',
      client: {},
      isShow: false
    }
  },
  components: {
    Form
  },
  methods: {
    redirectBack() {
      this.$router.replace('/admin/api-management')
    },
    getClient() {
      APIDataService.get(this.$route.params.id)
        .then(response => {
          console.log(response)
          this.client = response.data['data']['api_data']
        })
        .catch(e => {
          ErrorHandler(e)
        });
    },
    onSubmit(data) {
      APIDataService.update(this.$route.params.id, data)
        .then(() => {
          this.alertType = 'Success'
          this.alertMessage = 'API Management successfuly Updated'
          this.countDownTimer(3, this.redirectBack)
        })
        .catch(e => {
          this.alertType = 'Failed'
          this.alertMessage = e.response.data.code_message
          this.countDownTimer(3)
          console.log(e);
        });
    },
    countDownTimer(countDown, callback) {
      if (countDown > 0) {
        setTimeout(() => {
          countDown -= 1
          this.countDownTimer(countDown, callback)
        }, 1000)
      } else {
        this.alertType = ''
        if (callback != undefined) {
          callback()
        }
      }
    }
  }
};
</script>
